// @flow
type State = {
  authenticated: boolean,
  token: ?string,
};

type Action = {
  type: string,
  payload: Object,
};

const initialState = {
  authenticated: false,
  token: null,
};

export default function auth(state: State = initialState, action: Action) {
  switch (action.type) {
    case 'login': {
      return {
        authenticated: true,
        token: action.payload.token,
      };
    }
    case 'logout': {
      return {
        authenticated: false,
        token: null,
      };
    }
    default: {
      return state;
    }
  }
}



// WEBPACK FOOTER //
// ./src/reducers/auth.js